import LayerGroup from "ol/layer/Group";
import LayerTile from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";

const karagatanURL = process.env.GEOSERVER;
const attEOG =
  '<a href="https://eogdata.mines.edu/vbd/">Earth Observation Group, Payne Institute for Public Policy</a>';

const viirs_2026 = new LayerGroup({
  title: "2026",
  fold: "open",
  layers: [
    ///////////monthly
    new LayerTile({
      title: "2026 January",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_january",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2026 February",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_february",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2026 March",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_march",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2026 April",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_april",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2026 May",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_may",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2026 June",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_june",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2026 July",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_july",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2026 August",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_august",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2026 September",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_september",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
/////////////////////weekly/////////////////////////////
    new LayerTile({
      title: "27 September - 03 October2026",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_0927_1003",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "04 - 10 October2026",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_1004_1010",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "11 - 17 October2026",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026__1011_1017",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "18 - 24 October2026",
      visible: true,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2026_1018_1024",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
  ],
});

export default viirs_2026;
